// extracted by mini-css-extract-plugin
export default {"Photo":"Photo_Photo__kYYJP"};